import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ks599psfse: FaireBrandEntity = {
  token: "b_ks599psfse",
  type: "brand",
  name: "Psychedelic Pepper Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/9744ae1dd4e77bb58bac54b63cfd6a33a99460542c28bfac345582dfe7534a37.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a15769fb79dbc18bdcfbab0177752e5c18ff24fc645d8331f856e208011b50b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9744ae1dd4e77bb58bac54b63cfd6a33a99460542c28bfac345582dfe7534a37.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a15769fb79dbc18bdcfbab0177752e5c18ff24fc645d8331f856e208011b50b.jpeg",
  location: "Fort Edward, NY, USA",
  minimumOrderDollars: 75,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Psychedelic Pepper Company was born on May 27th 2022. We are a small business located in the beautiful Adirondacks of New York State. Starting a hot sauce business was never even a thought until one perfect night after a long day of work. I came home to make some dinner, tacos to be exact. Once the tacos were done and ready to plate, I opened the fridge and to my surprise we had no hot sauce... everyone knows you can't have tacos without hot sauce. So I started digging around in the fridge and found some day old pineapple chunks and a few jalapeno peppers. I had the bight idea in my head to just create my own sauce to compliment the meal. I will never forget the look on my girlfriends face when she took her first bite. She just looked at me with a huge smile and said \"Holy F*ck that might be the best taco I have ever had.\" That's the moment I knew I had stumbled upon something great. The very next morning I got on my computer and applied for my business license. Ever since that morning the company has grown faster than I could have ever imagined. Psychedelic Pepper Company strives to use nothing but the freshest ingredients we can get our hands on. We will continue to make delicious hot sauce that everyone can enjoy at a reasonable price. \n\nThank you,\n\nSteven Kalisz\n\nOwner/ Sauce Connoisseur",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:49.680Z",
    importedBy: "entity-db-cli",
  },
};
